module.exports = __webpack_public_path__ + "static/img/guide3.b037ea1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide3.webp
// module id = 2qam
// module chunks = 1